import { INPUT_STATE_ERROR } from '@yme/atoms/input';
import { INPUT_MAX_LENGTH, PERSONAL_DETAILS_INPUT_MAX_LENGTH } from '@yme/common/constants';
import { regExpValidationEmail, reqExpNumber } from '@yme/utils/regEx';
import { DISCOUNT_KEY, EMAIL_KEY, FIELD_SEPARATOR, FIRST_NAME_KEY, LAST_NAME_KEY, PERSONAL_DETAILS_EMAIL_KEY, PERSONAL_DETAILS_FIRST_NAME_KEY, PERSONAL_DETAILS_LAST_NAME_KEY, PERSONAL_DETAILS_PHONE_KEY, PHONE_KEY, SALUTATION_KEY, } from './constants';
export const putFieldNameIntoErrorText = (message, fieldName) => {
    const splitedText = message.split(FIELD_SEPARATOR);
    return [splitedText[0], fieldName, splitedText[1]].join('');
};
export const getErrorState = (item) => item?.errorCode?.length ? INPUT_STATE_ERROR : undefined;
export const getInfoText = (item, message, fieldName) => item?.errorCode?.length ? putFieldNameIntoErrorText(message, fieldName) : undefined;
export const getSimpleErrorMessage = (item, message) => item?.errorCode?.length ? message : undefined;
export const isFieldValidated = (fieldValue, maxLength, isRequired = true, minLength = 0) => (isRequired ? fieldValue.length > minLength : true) && fieldValue.length <= maxLength;
export const hasEmailValidation = (value, regExp, isRequired) => {
    const trimmedValue = value.trim();
    const isEmptyAndRequired = trimmedValue ? isValidEmail(trimmedValue) : !isRequired;
    return isEmptyAndRequired && isFieldValidated(trimmedValue, INPUT_MAX_LENGTH.email, isRequired);
};
export const hasPhoneValidation = (value, isRequired) => {
    const trimmedValue = value.trim();
    return isFieldValidated(trimmedValue, INPUT_MAX_LENGTH.phoneNumber, isRequired);
};
const hasFirstNameValidation = (value, isRequired) => {
    const trimmedValue = value.trim();
    return isFieldValidated(trimmedValue, INPUT_MAX_LENGTH.firstName, isRequired);
};
const hasLastNameValidation = (value, isRequired) => {
    const trimmedValue = value.trim();
    return isFieldValidated(trimmedValue, INPUT_MAX_LENGTH.lastName, isRequired);
};
const hasSalutationValidation = (value, isRequired) => {
    const trimmedValue = value ? value.trim() : '';
    return isFieldValidated(trimmedValue, INPUT_MAX_LENGTH.default, isRequired);
};
const hasPersonalDetailsEmailValidation = (value, regExp, isRequired) => {
    const trimmedValue = value.trim();
    const isEmptyAndRequired = trimmedValue ? regExp.test(trimmedValue) : !isRequired;
    return (isEmptyAndRequired &&
        isFieldValidated(trimmedValue, PERSONAL_DETAILS_INPUT_MAX_LENGTH.email, isRequired));
};
export function isValidEmail(email) {
    return regExpValidationEmail.test(email);
}
const hasPersonalDetailsPhoneValidation = (value, regExp, isRequired) => {
    const trimmedValue = value.trim();
    const isEmptyAndRequired = trimmedValue ? regExp.test(trimmedValue) : !isRequired;
    return (isEmptyAndRequired &&
        isFieldValidated(trimmedValue, PERSONAL_DETAILS_INPUT_MAX_LENGTH.email, isRequired));
};
const hasPersonalDetailsFirstNameValidation = (value, isRequired) => {
    const trimmedValue = value.trim();
    return isFieldValidated(trimmedValue, PERSONAL_DETAILS_INPUT_MAX_LENGTH.firstName, isRequired, 1);
};
const hasPersonalDetailsLastNameValidation = (value, isRequired) => {
    const trimmedValue = value.trim();
    return isFieldValidated(trimmedValue, PERSONAL_DETAILS_INPUT_MAX_LENGTH.lastName, isRequired, 1);
};
export const getValidation = (value, type, isRequired) => {
    switch (type) {
        case FIRST_NAME_KEY:
            return hasFirstNameValidation(value, isRequired);
        case LAST_NAME_KEY:
            return hasLastNameValidation(value, isRequired);
        case PHONE_KEY:
            return hasPhoneValidation(value, isRequired);
        case EMAIL_KEY:
            return hasEmailValidation(value, regExpValidationEmail, isRequired);
        case SALUTATION_KEY:
            return hasSalutationValidation(value, isRequired);
        case DISCOUNT_KEY:
            return true;
        case PERSONAL_DETAILS_FIRST_NAME_KEY:
            return hasPersonalDetailsFirstNameValidation(value, isRequired);
        case PERSONAL_DETAILS_LAST_NAME_KEY:
            return hasPersonalDetailsLastNameValidation(value, isRequired);
        case PERSONAL_DETAILS_PHONE_KEY:
            return hasPersonalDetailsPhoneValidation(value, reqExpNumber, isRequired);
        case PERSONAL_DETAILS_EMAIL_KEY:
            return hasPersonalDetailsEmailValidation(value, regExpValidationEmail, isRequired);
        default:
            return false;
    }
};
